module.exports = __webpack_public_path__ + "static/img/bg_1.c19fa82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/bg_1.jpg
// module id = GYQo
// module chunks = 0